<!-- 工单备注 -->
<template>
  <a-modal
    v-model:visible="visible"
    title="填写工单备注"
    @ok="submitRemarks"
    centered
    wrapClassName="order-remark"
  >
    <Textarea
      v-model:value="remark"
      :maxlength="200"
      :showCount="true"
      placeholder="请输入备注内容～"
      :rows="4"
    />
    <template v-slot:footer>
      <div class="z-flex-c">
        <div class="font-12-4 editor">
          <template v-if="info.remark && info?.updateRemarkRecordReq?.updateDate">
            {{ formatDate(info?.updateRemarkRecordReq?.updateDate, 2) }}&nbsp; &nbsp;
            {{ concatEditor('健管', info?.updateRemarkRecordReq?.name) }}
          </template>
        </div>
        <a-space>
          <a-popconfirm
            title="确定要清除备注吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="clearRemarks"
            :disabled="!remark"
          >
            <a-button :disabled="!remark">清除备注</a-button>
          </a-popconfirm>
          <a-button type="primary" @click="submitRemarks" :loading="loading">确定</a-button>
        </a-space>
      </div>
    </template>
  </a-modal>
</template>
<script setup>
import Textarea from '@/components/cus-textarea'
import { ref, defineExpose, reactive } from 'vue'
import { addWorkOrderRemark } from '@/api/chat'
import { message } from 'ant-design-vue'
import { formatDate, concatEditor } from '@/utils'
import { REFRESH_MAIN } from '@/views/WorkPlace/handleEventBuss'

const info = reactive({})
const visible = ref(false)
const remark = ref('')
const loading = ref(false)
// 更新工单备注
const submitRemarks = type => {
  if (loading.value) return
  loading.value = true
  const params = {
    workOrderId: info.workOrderId,
    remark: remark.value?.trim()
  }
  addWorkOrderRemark(params)
    .then(() => {
      visible.value = false
      message.success(type === 'clear' ? '清除成功！' : '添加成功！')
      REFRESH_MAIN?.emit()
    })
    .finally(() => {
      // 提交之后初始化备注数据
      remark.value = ''
      loading.value = false
    })
}
// 清除工单备注
const clearRemarks = () => {
  remark.value = ''
  submitRemarks('clear')
}
const initModal = param => {
  Object.assign(info, param.info)
  console.log(99, info)
  remark.value = info?.remark ?? ''
  visible.value = true
}
defineExpose({ initModal })
</script>
<style lang="scss">
.editor {
  min-width: 150px;
}
</style>
